import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueStorage from 'vue-ls'

import Vant from 'vant';
import api from '@/http/index'
import _ from 'lodash'

Vue.use(VueStorage, {
  namespace: 'larkcarmb__',
  name: 'ls',
  storage: 'local',
})
Vue.use(Vant);
Vue.use(api)
Vue.config.ignoredElements = ["wx-open-subscribe"]

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
